import { render, staticRenderFns } from "./ManageAddresseeEmailView.vue?vue&type=template&id=7cfd65be"
import script from "./ManageAddresseeEmailView.vue?vue&type=script&lang=ts"
export * from "./ManageAddresseeEmailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports